import TextField from '@mui/material/TextField';

function NumberField({ label, value, onChange, min, max, helperText }) {
  return (
    <TextField
      label={label}
      type="number"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      helperText={helperText}
      inputMode="decimal"
      InputProps={{
        inputProps: {
          min,
          max,
          step: 'any',
          inputMode: 'decimal',
        },
      }}
    />
  );
}

export default NumberField;
